import HeroSection from "@/pages/home/components/HeroSection";
import FeaturedCarousel from "@/pages/home/components/FeaturedCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import HotRanking from "@/pages/home/components/HotRanking";
import SiteIntro from "@/pages/home/components/SiteIntro";
import SectionHeading from "@/components/base/SectionHeading";
import MiniSiteCard from "@/components/feature/MiniSiteCard";
import { useSEO } from "@/hooks/useSEO";
import { getFeatured, getHot, getLatest } from "@/lib/navData";

export default function Home() {
  useSEO(
    "51网址导航-权威实用网址快速访问门户",
    "51网址导航为用户提供全面实用的网址导航服务，涵盖热门网站入口、分类索引及最新互联网资源，方便快捷地访问各类网站。",
    "/",
  );

  const featured = getFeatured(6);
  const latest = getLatest(6);
  const hot = getHot(10);

  return (
    <div>
      <HeroSection />

      <section className="max-w-page mx-auto px-4 md:px-6 py-12 md:py-16">
        <SectionHeading
          icon="ri-star-line"
          title="焦点网址推荐"
          subtitle="本月最热门与编辑精选的优质网站入口"
        />
        <FeaturedCarousel sites={featured} />
      </section>

      <section className="bg-background-100 border-y border-background-200">
        <div className="max-w-page mx-auto px-4 md:px-6 py-12 md:py-16">
          <SectionHeading
            icon="ri-apps-2-line"
            title="分类快捷入口"
            subtitle="按类别浏览，快速找到你需要的网站"
          />
          <CategoryGrid />
        </div>
      </section>

      <section className="max-w-page mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <SectionHeading
              icon="ri-time-line"
              title="最新更新网址"
              subtitle="按收录时间展示最近加入的网站"
              moreTo="/search"
              moreLabel="浏览全部网址"
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {latest.map((site) => (
                <MiniSiteCard key={site.id} site={site} />
              ))}
            </div>
          </div>

          <div>
            <SectionHeading
              icon="ri-fire-line"
              title="热门网址排行榜"
              subtitle="访问量最高的常用网站"
            />
            <HotRanking sites={hot} />
          </div>
        </div>
      </section>

      <section className="bg-background-100 border-y border-background-200">
        <div className="max-w-page mx-auto px-4 md:px-6 py-14 md:py-20">
          <SiteIntro />
        </div>
      </section>
    </div>
  );
}